import React, { useState, useContext, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTransition } from 'react-spring';
import useShowStickyNavigation from '../../hooks/useShowStickyNavigation';
import { VehicleDetails } from '../../types';
import { vehicleContext } from '../VehicleProvider';
import Modal from '../Modal';
import LegalText from '../LegalText';
import {
  Nav,
  NavWrapper,
  ModelInfoContainer,
  ModelName,
  Legal,
  TextContainer,
} from './StickyNavbar.styles';
import CTASection from '../CTASection';
import PriceBlock from './PriceBlock';
import StatusBlock from './StatusBlock';

const StickyNavBar: React.FC = () => {
  const { vehicle } = useContext(vehicleContext);

  const { modelName } = (vehicle as VehicleDetails) ?? {};

  const isTablet = useMediaQuery({ minWidth: 768 });

  const visible = useShowStickyNavigation();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const onModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const onModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const transitions = useTransition(visible, null, {
    initial: null,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 150 },
  });

  if (!vehicle) return null;

  return (
    <>
      {transitions.map(
        ({ item, key, props }) =>
          item && (
            <NavWrapper key={key} style={props}>
              <Nav>
                <ModelInfoContainer>
                  {isTablet && <StatusBlock />}
                  {isTablet && <ModelName data-testid="model-name">{modelName}</ModelName>}
                  <PriceBlock onModalOpen={onModalOpen} />
                </ModelInfoContainer>
                <CTASection isSticky />
              </Nav>
            </NavWrapper>
          ),
      )}
      {modalOpen && (
        <Modal onClose={onModalClose} modalOpen={modalOpen}>
          <Legal>
            <TextContainer>
              <LegalText hasLongText />
            </TextContainer>
          </Legal>
        </Modal>
      )}
    </>
  );
};

export default StickyNavBar;
